import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';

export const VehiclesDescriptionWrapper = styled.div`
  line-height: 1.1;
  div.vehicle-description {
    padding-bottom: 0.5rem;
    font-weight: bold;
    color: ${COLORS.BLACK_3};
  }
  div.vehicle-contract-info {
    padding-bottom: 0.5rem;
  }
`;
